import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=bbf7e18c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=bbf7e18c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf7e18c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbf7e18c')) {
      api.createRecord('bbf7e18c', component.options)
    } else {
      api.reload('bbf7e18c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=bbf7e18c&scoped=true&", function () {
      api.rerender('bbf7e18c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2j5GmkMgYfn87/JS/comp/GuestBox.vue"
export default component.exports